<template>
  <div class="Alk-wrap">
    <!-- <van-sticky>
      <div class="search">
        <div class="close" @click="onCancel()" v-if="$route.query.wx != 'wx'">
          <van-icon size="20px" name="arrow-left" />
        </div>
        
        <form action="/" style="width: 100%">
          <van-search
            v-model="value"
            placeholder="请输入基因搜索"
             shape="round"
            @search="onSearch"
            @cancel="onCancel"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </form>
      </div>
    </van-sticky> -->
    <!-- <div style="height:200vh"></div> -->
    <!-- <van-list
      v-model="loading"
      :finished="finished"
      finished-text=""
      :offset="10"
      :immediate-check="false"
      @load="onLoad"
      class="van-load"
    > -->
    <div class="Alk" v-for="(item, index) in list" :key="index">
      <h1 class="title">{{ item.geneName }}</h1>
      <div class="show-box"></div>
      <div class="content">
        <div class="text-content">
          <p>突变类型</p>
          <h2>{{ item.mutationType }}</h2>
        </div>
        <div class="text-content">
          <p>检测结果</p>
          <h2 class="result">
            {{ item.testResult }}
          </h2>
        </div>
        <div v-for="(i, index) in item.categoryMaps" :key="index">
          <div class="text-content">
            <p>类别</p>
            <h2>{{ i.category }}</h2>
          </div>
          <div class="text-content">
            <p>解析</p>
            <h2 v-html="i.analysis"></h2>
          </div>
        </div>
      </div>
    </div>
    <!-- </van-list> -->
    <Empty v-if="isEmpty" />
  </div>
</template>
<script>
import { getAlk } from "@/api/reportQuery";
import { mapState } from "vuex";
import isiOS from "@/utils/iosAn";
export default {
  props: {
    moduleAnnotation: {
      type: String,
    },
    title: {
      type: String,
    },
    moduleIsShow: {
      type: String,
    },
    templateIsShow: {
      type: String,
    },
    templateId: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      pagesize: 4,
      list: [],
      total: 0,
      isEmpty: false,
      value: "",
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  created() {},
  mounted() {
    this.getDataList();
  },
  watch: {
    value: function (val) {
      if (!val) {
        this.getDataList(val);
      }
    },
  },
  methods: {
    onSearch(val) {
      this.list = [];
      this.getDataList(val);
      console.log(val);
    },
    onCancel() {
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          type: "9000",
        });
      } else {
        window.android.JSCallNative(JSON.stringify({ type: "9000", name: "" }));
      }
    },
    getDataList(geneName) {
      getAlk({
        geneName: geneName,
        // labOriginalSampleNo: "F21091895T",
        labOriginalSampleNo: this.$route.query.fname,
        moduleId: this.$route.query.moduleId,
        // productCode: "fwa-p825",
        productCode: this.$route.query.fid,
      }).then((res) => {
        this.isEmpty = false;

        // let rows = res.data;
        this.list = res.data;
        // this.loading = false;
        // this.total = res.data.total;
        // if (rows == null || rows.length === 0) {
        //   // 加载结束
        //   this.finished = true;
        //   this.list = [];
        //   this.isEmpty = true;

        //   return;
        // }
        // this.list = this.list.concat(rows);

        // if (this.list.length >= this.total) {
        //   this.finished = true;
        // }
        // if (this.list == "") {
        //   this.isEmpty = true;
        // } else {
        //   this.isEmpty = false;
        // }
      });
    },
    onLoad() {
      this.page++;
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}
/deep/.van-sticky--fixed {
  // background: #fff;
  padding-bottom: 6px;
  background: url("../../assets/head-bg.png") no-repeat;
  background-size: 100% auto;
  padding: 40px 20px 20px;
  // .sticky {
  //   padding-bottom: 6px;
  //   background:url('../../assets/head-bg.png') no-repeat;
  //   background-size: 100% 100%;
  // }
}

.Alk-wrap {
  padding: 0px 20px;
  overflow-y: scroll;
  height: 100vh;
  // background: url("../../assets/head-bg.png") no-repeat;
  background-size: 100% auto;
  padding: 0 16px;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    display: none;
  }
  .search {
    height: 44px;
    padding-top: 14px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .close {
      min-width: 30px;
    }
    /deep/.van-search {
      padding: 0;
      background: transparent;
      /deep/.van-cell {
        font-size: 12px;
        align-items: center;
      }
    }
    /deep/.van-search__content {
      background: none;
      border: 1px solid #e3e5e8;
      border-radius: 18px;
    }
    /deep/.van-search__action {
      color: #9095a7;
      font-size: 16px;
    }
    /deep/.van-field__control {
      color: #9095a7;
    }
  }
}
/deep/.Alk {
  i {
    font-style: normal;
  }
}
.Alk {
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  font-family: @family;
  margin-top: 20px;

  .content {
    margin-bottom: 24px;
    padding: 10px 24px 10px;
    .text-content {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .result {
        color: #28d4e5;
      }

      h2 {
        font-size: 13px;
        font-weight: 500;
        color: #2f354d;
        line-height: 18px;
        word-break: break-all;
        text-align: justify;
        text-justify: newspaper;
        margin-bottom: 20px;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 17px;
        margin-bottom: 4px;
      }
    }
    h1 {
      font-size: 18PX;
      padding-left: 12px;
      font-weight: 500;
      color: #27ca8d;
      line-height: 22px;
      position: relative;
      margin-bottom: 20px;
      &::before {
        content: "";
        position: absolute;
        width: 3px;
        left: 0;
        top: 50%;
        margin-top: -7px;
        height: 14px;
        background: #27ca8d;
        border-radius: 2px;
      }
    }
  }
  h1 {
    font-size: 18PX;
    font-family: @family;
    font-weight: 500;
    color: #4b84ff;
    height: 70px;
    line-height: 70px;
    padding-left: 24px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      width: 3px;
      left: 0;
      top: 50%;
      margin-top: -7px;
      height: 14px;
      background: #4b84ff;
      border-radius: 2px;
    }
  }
}
</style>
